import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from "@angular/common/http";
import {ApiUrlService, getFilenameFromHttpHeaders} from "@digidom/common";

// TODO: Create base export service.
@Injectable({
  providedIn: 'root'
})
export class ExportLeadsService {

  constructor(protected http: HttpClient, protected apiUrlService: ApiUrlService) {
  }

  public export() {

    this.http.get<Blob>(this.getUrl(), {
      observe: 'response',
      responseType: 'blob' as 'json'
    }).subscribe((resp: HttpResponse<Blob>) => {

      if (!resp.body){
        throw new Error('Export response missing body');
      }

      const link = document.createElement('a');
      const filename = getFilenameFromHttpHeaders(resp.headers);
      link.href = window.URL.createObjectURL(resp.body);
      link.download = filename ? filename : 'leads.csv';
      link.click();

      return true;

    });

  }

  protected getUrl() {
    return this.apiUrlService.url('exportLeads');
  }
}
